import React, { lazy, Suspense } from 'react';

const TemplatesGallery = lazy(() =>
  import(/* webpackChunkName: "templates-gallery" */ './TemplatesGallery'));

export const LazyTemplatesGallery: React.FunctionComponent = () => {
  return (
    <Suspense fallback={null}>
      <TemplatesGallery />
    </Suspense>
  );
};
